import React from "react"
import { FaCheckCircle, FaMinusCircle, FaTimesCircle } from "react-icons/fa"

import { productUnitsSymbol } from "constant"
import classes from "./StrrdmReceiveTableRow.module.scss"

const StrrdmReceiveTableRow = (props) => {
  const { requestedItem } = props

  const isItemReceivedCompletly =
    requestedItem.acceptedQuantity === requestedItem.receivedQuantity

  const isItemReceivedPartialy =
    requestedItem.receivedQuantity !== 0 &&
    requestedItem.acceptedQuantity !== requestedItem.receivedQuantity

  const isItemNotReceived =
    requestedItem.receivedQuantity === 0

  const getBackgroundColor = () => {
    if (isItemReceivedCompletly)
      return "var(--color-success-alpha-25)"

    if (isItemReceivedPartialy)
      return "var(--color-warning-alpha-25)"

    return "var(--color-danger-alpha-25)"
  }

  const backgroundColor = getBackgroundColor()

  return (
    <tr style={{ backgroundColor }} >
      <td>
        {
          isItemReceivedCompletly &&
          <FaCheckCircle
            size={16}
            className={classes["check"]}
          />
        }
        {
          isItemReceivedPartialy &&
          <FaMinusCircle
            size={16}
            className={classes["minus"]}
          />
        }
        {
          isItemNotReceived &&
          <FaTimesCircle
            size={16}
            className={classes["times"]}
          />
        }
      </td>
      <td>
        {requestedItem.foodName}{" "}
        {requestedItem.isSimple ? "" : requestedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.requestedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.acceptedQuantity}{productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.receivedQuantity}{productUnitsSymbol[requestedItem.unit]}
      </td>
    </tr>
  )
}

export default StrrdmReceiveTableRow